// Permissions
// Main
// Dashboard
export const DASHBOARD = {
  group: 'Main',
  name: 'Dashboard',
  type: 'view'
}
// Budget Plan
export const BUDGET_ADD = {
  group: 'Main',
  name: 'Budget',
  type: 'add'
}
export const BUDGET_DELETE = {
  group: 'Main',
  name: 'Budget',
  type: 'delete'
}
export const BUDGET_EDIT = {
  group: 'Main',
  name: 'Budget',
  type: 'edit'
}
export const BUDGET_PRINT_EXPORT = {
  group: 'Main',
  name: 'Budget',
  type: 'print export'
}
export const BUDGET_UPLOAD = {
  group: 'Main',
  name: 'Budget',
  type: 'upload'
}
export const BUDGET_VIEW = {
  group: 'Main',
  name: 'Budget',
  type: 'view'
}
// Work Order
export const WORK_ORDER_VIEW = {
  group: 'Main',
  name: 'Work order',
  type: 'view'
}
export const WORK_ORDER_ADD = {
  group: 'Main',
  name: 'Work order',
  type: 'add'
}
export const WORK_ORDER_APPROVE = {
  group: 'Main',
  name: 'Work order',
  type: 'approval'
}
export const WORK_ORDER_DELETE = {
  group: 'Main',
  name: 'Work order',
  type: 'delete'
}
export const WORK_ORDER_EDIT = {
  group: 'Main',
  name: 'Work order',
  type: 'edit'
}
export const WORK_ORDER_REVISE = {
  group: 'Main',
  name: 'Work order',
  type: 'revise'
}
// Logsheet / Log Sheet
export const LOGSHEET_VIEW = {
  group: 'Main',
  name: 'Logsheet',
  type: 'view'
}
export const LOGSHEET_UPLOAD = {
  group: 'Main',
  name: 'Logsheet',
  type: 'upload'
}
export const LOGSHEET_APPROVE = {
  group: 'Main',
  name: 'Logsheet',
  type: 'approval'
}
export const LOGSHEET_DELETE = {
  group: 'Main',
  name: 'Logsheet',
  type: 'delete'
}
export const LOGSHEET_EDIT = {
  group: 'Main',
  name: 'Logsheet',
  type: 'edit'
}
export const LOGSHEET_REVISE = {
  group: 'Main',
  name: 'Logsheet',
  type: 'revise'
}
export const LOGSHEET_UPLOAD_PHOTO = {
  group: 'Main',
  name: 'Logsheet',
  type: 'upload photo'
}
export const LOGSHEET_PRINT = {
  group: 'Main',
  name: 'Logsheet',
  type: 'print'
}
// Report
// HM EWH
export const HM_EWH_VIEW = {
  group: 'Reports',
  name: 'HM EWH',
  type: 'view'
}
export const HM_EWH_APPROVE = {
  group: 'Reports',
  name: 'HM EWH',
  type: 'approval'
}
export const HM_EWH_COMMENT = {
  group: 'Reports',
  name: 'HM EWH',
  type: 'comment'
}
export const HM_EWH_DELETE = {
  group: 'Reports',
  name: 'HM EWH',
  type: 'delete'
}
export const HM_EWH_EDIT = {
  group: 'Reports',
  name: 'HM EWH',
  type: 'edit'
}
export const HM_EWH_PRINT = {
  group: 'Reports',
  name: 'HM EWH',
  type: 'print'
}
export const HM_EWH_ADD = {
  group: 'Reports',
  name: 'HM EWH',
  type: 'add'
}
// Summary Progress
export const SUMMARY_PROGRESS_ADD = {
  group: 'Reports',
  name: 'Summary Progress',
  type: 'add'
}
export const SUMMARY_PROGRESS_APPROVE = {
  group: 'Reports',
  name: 'Summary Progress',
  type: 'approval'
}
export const SUMMARY_PROGRESS_COMMENT = {
  group: 'Reports',
  name: 'Summary Progress',
  type: 'comment'
}
export const SUMMARY_PROGRESS_DELETE = {
  group: 'Reports',
  name: 'Summary Progress',
  type: 'delete'
}
export const SUMMARY_PROGRESS_EDIT = {
  group: 'Reports',
  name: 'Summary Progress',
  type: 'edit'
}
export const SUMMARY_PROGRESS_PRINT = {
  group: 'Reports',
  name: 'Summary Progress',
  type: 'print'
}
export const SUMMARY_PROGRESS_VIEW = {
  group: 'Reports',
  name: 'Summary Progress',
  type: 'view'
}
// Backup Payment
export const BACKUP_PAYMENT_ADD = {
  group: 'Reports',
  name: 'Backup Payment',
  type: 'add'
}
export const BACKUP_PAYMENT_APPROVE = {
  group: 'Reports',
  name: 'Backup Payment',
  type: 'approval'
}
export const BACKUP_PAYMENT_COMMENT = {
  group: 'Reports',
  name: 'Backup Payment',
  type: 'comment'
}
export const BACKUP_PAYMENT_DELETE = {
  group: 'Reports',
  name: 'Backup Payment',
  type: 'delete'
}
export const BACKUP_PAYMENT_EDIT = {
  group: 'Reports',
  name: 'Backup Payment',
  type: 'edit'
}
export const BACKUP_PAYMENT_PRINT = {
  group: 'Reports',
  name: 'Backup Payment',
  type: 'print'
}
export const BACKUP_PAYMENT_VIEW = {
  group: 'Reports',
  name: 'Backup Payment',
  type: 'view'
}
// PAF1
export const PAF_ADD = {
  group: 'Reports',
  name: 'PAF',
  type: 'add'
}
export const PAF_APPROVE = {
  group: 'Reports',
  name: 'PAF',
  type: 'approval'
}
export const PAF_COMMENT = {
  group: 'Reports',
  name: 'PAF',
  type: 'comment'
}
export const PAF_PRINT = {
  group: 'Reports',
  name: 'PAF',
  type: 'print'
}
export const PAF_VIEW = {
  group: 'Reports',
  name: 'PAF',
  type: 'view'
}
export const PAF_TABLE = {
  group: 'Reports',
  name: 'PAF',
  type: 'PAF1'
}
// PAF2
export const PAF2_APPROVE = {
  group: 'Reports',
  name: 'PAF2',
  type: 'approval'
}
export const PAF2_COMMENT = {
  group: 'Reports',
  name: 'PAF2',
  type: 'comment'
}
export const PAF2_PRINT = {
  group: 'Reports',
  name: 'PAF2',
  type: 'print'
}
export const PAF2_VIEW = {
  group: 'Reports',
  name: 'PAF2',
  type: 'view'
}
// Settings
// Fuel price
export const FUEL_PRICE_ADD = {
  group: 'Settings',
  name: 'Fuel price',
  type: 'add'
}
export const FUEL_PRICE_DELETE = {
  group: 'Settings',
  name: 'Fuel price',
  type: 'delete'
}
export const FUEL_PRICE_EDIT = {
  group: 'Settings',
  name: 'Fuel price',
  type: 'edit'
}
export const FUEL_PRICE_VIEW = {
  group: 'Settings',
  name: 'Fuel price',
  type: 'view'
}
// Equipment type
export const EQUIPMENT_TYPE_ADD = {
  group: 'Settings',
  name: 'Equipment type',
  type: 'add'
}
export const EQUIPMENT_TYPE_DELETE = {
  group: 'Settings',
  name: 'Equipment type',
  type: 'delete'
}
export const EQUIPMENT_TYPE_EDIT = {
  group: 'Settings',
  name: 'Equipment type',
  type: 'edit'
}
export const EQUIPMENT_TYPE_VIEW = {
  group: 'Settings',
  name: 'Equipment type',
  type: 'view'
}
// Contractor
export const CONTRACTOR_ADD = {
  group: 'Settings',
  name: 'Contractor',
  type: 'add'
}
export const CONTRACTOR_DELETE = {
  group: 'Settings',
  name: 'Contractor',
  type: 'delete'
}
export const CONTRACTOR_EDIT = {
  group: 'Settings',
  name: 'Contractor',
  type: 'edit'
}
export const CONTRACTOR_VIEW = {
  group: 'Settings',
  name: 'Contractor',
  type: 'view'
}
// Employee
export const EMPLOYEE_ADD = {
  group: 'Settings',
  name: 'Employee',
  type: 'add'
}
export const EMPLOYEE_DELETE = {
  group: 'Settings',
  name: 'Employee',
  type: 'delete'
}
export const EMPLOYEE_EDIT = {
  group: 'Settings',
  name: 'Employee',
  type: 'edit'
}
export const EMPLOYEE_VIEW = {
  group: 'Settings',
  name: 'Employee',
  type: 'view'
}
// Role
export const ROLE_ADD = {
  group: 'Settings',
  name: 'Role',
  type: 'add'
}
export const ROLE_DELETE = {
  group: 'Settings',
  name: 'Role',
  type: 'delete'
}
export const ROLE_EDIT = {
  group: 'Settings',
  name: 'Role',
  type: 'edit'
}
export const ROLE_VIEW = {
  group: 'Settings',
  name: 'Role',
  type: 'view'
}
// Company
export const COMPANY_ADD = {
  group: 'Settings',
  name: 'Company',
  type: 'add'
}
export const COMPANY_DELETE = {
  group: 'Settings',
  name: 'Company',
  type: 'delete'
}
export const COMPANY_EDIT = {
  group: 'Settings',
  name: 'Company',
  type: 'edit'
}
export const COMPANY_VIEW = {
  group: 'Settings',
  name: 'Company',
  type: 'view'
}

// Summary Progress Data Survey
export const SUMMARY_PROGRESS_DATA_SURVEY_ADD = {
  group: 'Summary Survey',
  name: 'Upload Survey Data',
  type: 'add'
}
export const SUMMARY_PROGRESS_DATA_SURVEY_DELETE = {
  group: 'Summary Survey',
  name: 'Upload Survey Data',
  type: 'delete'
}
export const SUMMARY_PROGRESS_DATA_SURVEY_EDIT = {
  group: 'Summary Survey',
  name: 'Upload Survey Data',
  type: 'edit'
}
export const SUMMARY_PROGRESS_DATA_SURVEY_UPLOAD = {
  group: 'Summary Survey',
  name: 'Upload Survey Data',
  type: 'upload'
}
export const SUMMARY_PROGRESS_DATA_SURVEY_VIEW = {
  group: 'Summary Survey',
  name: 'Upload Survey Data',
  type: 'view'
}

// Resume Volume Work
export const RESUME_VOLUME_WORK_ADD = {
  group: 'Summary Survey',
  name: 'Resume Volume Work',
  type: 'add'
}
export const RESUME_VOLUME_WORK_DELETE = {
  group: 'Summary Survey',
  name: 'Resume Volume Work',
  type: 'delete'
}
export const RESUME_VOLUME_WORK_EDIT = {
  group: 'Summary Survey',
  name: 'Resume Volume Work',
  type: 'edit'
}
export const RESUME_VOLUME_WORK_UPLOAD = {
  group: 'Summary Survey',
  name: 'Resume Volume Work',
  type: 'upload'
}
export const RESUME_VOLUME_WORK_VIEW = {
  group: 'Summary Survey',
  name: 'Resume Volume Work',
  type: 'view'
}

// Volume Calculation
export const VOLUME_CALCULATION_ADD = {
  group: 'Summary Survey',
  name: 'Volume Calculation',
  type: 'add'
}
export const VOLUME_CALCULATION_DELETE = {
  group: 'Summary Survey',
  name: 'Volume Calculation',
  type: 'delete'
}
export const VOLUME_CALCULATION_EDIT = {
  group: 'Summary Survey',
  name: 'Volume Calculation',
  type: 'edit'
}
export const VOLUME_CALCULATION_UPLOAD = {
  group: 'Summary Survey',
  name: 'Volume Calculation',
  type: 'upload'
}
export const VOLUME_CALCULATION_VIEW = {
  group: 'Summary Survey',
  name: 'Volume Calculation',
  type: 'view'
}

// Overburden
export const OVERBURDEN_ADD = {
  group: 'BUP',
  name: 'Overburden',
  type: 'add'
}
export const OVERBURDEN_DELETE = {
  group: 'BUP',
  name: 'Overburden',
  type: 'delete'
}
export const OVERBURDEN_EDIT = {
  group: 'BUP',
  name: 'Overburden',
  type: 'edit'
}
export const OVERBURDEN_UPLOAD = {
  group: 'BUP',
  name: 'Overburden',
  type: 'upload'
}
export const OVERBURDEN_VIEW = {
  group: 'BUP',
  name: 'Overburden',
  type: 'view'
}

// Coal Auxilliary
export const COAL_AUXILLIARY_ADD = {
  group: 'BUP',
  name: 'Coal Auxilliary',
  type: 'add'
}
export const COAL_AUXILLIARY_DELETE = {
  group: 'BUP',
  name: 'Coal Auxilliary',
  type: 'delete'
}
export const COAL_AUXILLIARY_EDIT = {
  group: 'BUP',
  name: 'Coal Auxilliary',
  type: 'edit'
}
export const COAL_AUXILLIARY_UPLOAD = {
  group: 'BUP',
  name: 'Coal Auxilliary',
  type: 'upload'
}
export const COAL_AUXILLIARY_VIEW = {
  group: 'BUP',
  name: 'Coal Auxilliary',
  type: 'view'
}

// Coal Loading
export const COAL_LOADING_ADD = {
  group: 'BUP',
  name: 'Coal Loading',
  type: 'add'
}
export const COAL_LOADING_DELETE = {
  group: 'BUP',
  name: 'Coal Loading',
  type: 'delete'
}
export const COAL_LOADING_EDIT = {
  group: 'BUP',
  name: 'Coal Loading',
  type: 'edit'
}
export const COAL_LOADING_UPLOAD = {
  group: 'BUP',
  name: 'Coal Loading',
  type: 'upload'
}
export const COAL_LOADING_VIEW = {
  group: 'BUP',
  name: 'Coal Loading',
  type: 'view'
}

// RENTAL EQUIPMENT
export const RENTAL_EQUIPMENT_ADD = {
  group: 'BUP',
  name: 'Rental Equipment',
  type: 'add'
}
export const RENTAL_EQUIPMENT_DELETE = {
  group: 'BUP',
  name: 'Rental Equipment',
  type: 'delete'
}
export const RENTAL_EQUIPMENT_EDIT = {
  group: 'BUP',
  name: 'Rental Equipment',
  type: 'edit'
}
export const RENTAL_EQUIPMENT_UPLOAD = {
  group: 'BUP',
  name: 'Rental Equipment',
  type: 'upload'
}
export const RENTAL_EQUIPMENT_VIEW = {
  group: 'BUP',
  name: 'Rental Equipment',
  type: 'view'
}

// OTHER
export const OTHER_ADD = {
  group: 'BUP',
  name: 'Other',
  type: 'add'
}
export const OTHER_DELETE = {
  group: 'BUP',
  name: 'Other',
  type: 'delete'
}
export const OTHER_EDIT = {
  group: 'BUP',
  name: 'Other',
  type: 'edit'
}
export const OTHER_UPLOAD = {
  group: 'BUP',
  name: 'Other',
  type: 'upload'
}
export const OTHER_VIEW = {
  group: 'BUP',
  name: 'Other',
  type: 'view'
}

// SUMMARY
export const SUMMARY_ADD = {
  group: 'BUP',
  name: 'Summary',
  type: 'add'
}
export const SUMMARY_DELETE = {
  group: 'BUP',
  name: 'Summary',
  type: 'delete'
}
export const SUMMARY_EDIT = {
  group: 'BUP',
  name: 'Summary',
  type: 'edit'
}
export const SUMMARY_UPLOAD = {
  group: 'BUP',
  name: 'Summary',
  type: 'upload'
}
export const SUMMARY_VIEW = {
  group: 'BUP',
  name: 'Summary',
  type: 'view'
}

// approval doa
export const APPROVAL_DOA_ADD = {
  group: 'Settings',
  name: 'Approval Online Doa',
  type: 'add'
}
export const APPROVAL_DOA_DELETE = {
  group: 'Settings',
  name: 'Approval Online Doa',
  type: 'delete'
}
export const APPROVAL_DOA_EDIT = {
  group: 'Settings',
  name: 'Approval Online Doa',
  type: 'edit'
}
export const APPROVAL_DOA_VIEW = {
  group: 'Settings',
  name: 'Approval Online Doa',
  type: 'view'
}
